import { endpoint } from 'services/endpoint';
import { http, httpQ4US } from 'services/http';
import {
	TUpdateFiscalReportPaymentRequest,
	TUpdateFiscalReportPaymentResponse,
	TUpdateFiscalReportCommentRequest,
	TUpdateFiscalReportCommentResponse,
	TUpdateFiscalReportPaymentBody,
	TUpdateFiscalReportCommentBody,
	TExportFiscalXlsxRequest,
	TExportFiscalXlsxResponse,
	TSendPaidResponse,
	TSendReportRequest,
	TSendReportResponse,
	TCancelReportRequest,
	TCancelReportResponse,
} from 'redux/reducers/fiscalReports/types';
import { TFiscalReportsApi } from './types';

export const fiscalReports: TFiscalReportsApi = {
	getFiscalVatListInfoFilter: payload =>
		httpQ4US
			.get(endpoint.fiscalReports.GET_FISCAL_VAT_LIST_INFO_FILTER)
			.then(response => response.data),
	getFiscalReportList: payload =>
		httpQ4US
			.post(endpoint.fiscalReports.GET_FISCAL_REPORT_LIST, payload)
			.then(response => response.data),
	downloadFiscalPdf: payload =>
		httpQ4US
			.get(endpoint.fiscalReports.DOWNLOAD_FISCAL_PDF(payload.emId, payload.month, payload.year), {
				responseType: 'blob',
			})
			.then(response => response.data),
	downloadFiscalCsv: payload =>
		httpQ4US
			.get(
				endpoint.fiscalReports.DOWNLOAD_FISCAL_CSV(
					payload.emId,
					payload.month,
					payload.year,
					payload.countryCode,
					payload.scheme,
					payload.type,
				),
				{
					responseType: 'blob',
				},
			)
			.then(response => response.data),
	downloadFiscalXlsx: payload =>
		httpQ4US
			.get(
				endpoint.fiscalReports.DOWNLOAD_FISCAL_XLSX(
					payload.emId,
					payload.month,
					payload.year,
					payload.scheme,
				),
				{
					responseType: 'blob',
				},
			)
			.then(response => response.data),
	updateFiscalReportPayment: (payload: TUpdateFiscalReportPaymentBody) =>
		httpQ4US
			.post(endpoint.fiscalReports.UPDATE_FISCAL_REPORT_PAYMENT, payload)
			.then(response => response.data as TUpdateFiscalReportPaymentResponse),
	updateFiscalReportComment: (payload: TUpdateFiscalReportCommentBody) =>
		httpQ4US
			.post(endpoint.fiscalReports.UPDATE_FISCAL_REPORT_COMMENT, payload)
			.then(response => response.data as TUpdateFiscalReportCommentResponse),
	exportFiscalXlsx: (payload: TExportFiscalXlsxRequest) =>
		httpQ4US
			.post(endpoint.fiscalReports.EXPORT_FISCAL_XLSX, payload, {
				responseType: 'blob',
			})
			.then(response => response.data),
	sendPaid: () =>
		http
			.post(endpoint.fiscalReports.SEND_PAID)
			.then(response => response.data as TSendPaidResponse),
	sendReport: (payload: TSendReportRequest) =>
		http
			.post(
				endpoint.fiscalReports.SEND_REPORT(payload.reportId),
				payload.sendZero ? { sendZero: true } : { sendZero: false },
			)
			.then(response => response.data as TSendReportResponse),
	cancelReport: (reportId: string) =>
		http
			.post(endpoint.fiscalReports.CANCEL_REPORT(reportId))
			.then(response => response.data as TCancelReportResponse),
};
